import React from "react"
import { Link } from "gatsby"

const Music = ({ routeParams }) => (
  <div className="music-container">
    <div className="title-header">
      <h3 className="font-syne font-bold">MUSIC</h3>
    </div>
    <ul className="font-montserrat-13">
      <li>
        <div className="link">
          <Link to={`/${routeParams?.location}/reception/wedding-reception-music/`}>Reception Music</Link>
        </div>
      </li>
      <li>
        <div className="link">
          <Link to={`/${routeParams?.location}/ceremony/wedding-ceremony-music/`}>Ceremony Music</Link>
        </div>
      </li>
      <li>
        <div className="link">
          <Link to={`/${routeParams?.location}/wedding-music-packages/`}>Music Packages</Link>
        </div>
      </li>
    </ul>
  </div>
)

export default Music
